import { useMemo } from 'react';

import { Flex, Heading, Paragraph } from '@rover/kibble/core';
import Alert from '@rover/kibble/patterns/Alert';
import { FullStar } from '@rover/kibble/patterns/StarRating/StarRating.common';
import { AlertSeverity } from '@rover/react-lib/src/components/notifications/Alert/AlertSeverity';
import type { PersonTrainerProfile } from '@rover/rsdk/src/apiClient/latest/model/personTrainerProfile';
import type { ServiceTypeSimple } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSimple';
import { syndeticJoin } from '@rover/utilities/array';

function servicesToText(services: ServiceTypeSimple[]): string {
  const serviceNames = services.map((service) => service.name);
  serviceNames.sort((a, b) => {
    if (a === 'Dog Training') {
      return -1;
    }
    if (b === 'Dog Training') {
      return 1;
    }
    return a.localeCompare(b);
  });
  // TODO DEV-104195 Translate services before joining
  return syndeticJoin(serviceNames);
}

interface InsightsOverviewProps {
  trainerProfile: PersonTrainerProfile;
}
export default function InsightsOverview({ trainerProfile }: InsightsOverviewProps): JSX.Element {
  const servicesString = useMemo(
    () => servicesToText(trainerProfile.trainerInsights.servicesWithRatings),
    [trainerProfile]
  );
  const formattedRatingsAverage =
    trainerProfile.trainerInsights?.allServiceAverageRating?.toFixed(1);

  return (
    <Flex flexDirection="column">
      <Flex py="3x" gap="3x" alignItems="center">
        <FullStar size={24} disabled={false} />
        <Flex flexDirection="column">
          <Heading size="400" m="0x">
            {formattedRatingsAverage}
          </Heading>
          {/* TODO DEV-104195 Translate "for" */}
          <Paragraph size="100" textColor="tertiary" m="0x">
            for {servicesString}
          </Paragraph>
        </Flex>
      </Flex>
      <Alert severity={AlertSeverity.INFO} borderRadius="primary" borderWidth="0" mb="6x">
        <Paragraph size="100" m="0x">
          This star rating comes from verified services provided on Rover.
        </Paragraph>
      </Alert>
    </Flex>
  );
}
